import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allMeasurements: [],
    loading: false,
    error: null,
};

const measurementSlice = createSlice({
    name: 'measurement',
    initialState,
    reducers: {
        setAllMeasurements: (state, action) => {
            state.allMeasurements = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllMeasurements } = measurementSlice.actions;

export default measurementSlice.reducer;